module.exports = __webpack_public_path__ + "img/resultOne_web.abaccb8e.jpg";